<template>
	<component
		:is="tag"
		class="text-8xl lg:text-9xl lg:tracking-base xl:text-10xl"
		:class="{
			'font-sans tracking-xl normal-case': noStyle,
			'font-prenton-cond tracking-lg uppercase lg:tracking-base': !noStyle,
			'sr-only': isHidden,
		}"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
		noStyle?: boolean;
		isHidden?: boolean;
	}>(),
	{
		tag: "h1",
	},
);
</script>
